import React, { useState, useContext, useEffect } from "react";
import MUIDataTable from "mui-datatables";
import { useQuery } from "@apollo/react-hooks";
import { rolesQueries, rolesMutations } from "../../resolvers";
import { PersonsContext } from "../../contexts";
import {
  CustomToolbar,
  Loading,
  textLabels,
  CustomToolbarSelectWithUpdate,
} from "../../components";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import moment from "moment";
import { isMobile } from "react-device-detect";

const PageList = ({ currentcompany }) => {
  const { state, setState } = useContext(PersonsContext);
  const { data } = state.pageList;
  const [variables, setVariables] = useState({
    data: {
      isActive: true,
      company: currentcompany.id,
    },
  });

  const changeState = (value) => {
    setState({ ...state, ...value });
  };

  const [initialState, setInitialState] = useState(data ? data : []);

  const changeInitialState = (data) => {
    setInitialState(data);
  };

  const handleAdd = () => {
    changeState({
      page: "add",
      addUpdate: {
        data: {
          username: "",
          name: "",
          surname: "",
          password: "",
          company: "",
          type: "",
          isActive: true,
        },
      },
    });
  };

  const { loading, refetch } = useQuery(rolesQueries.PERSONS, {
    onCompleted({ Persons }) {
      changeState({
        pageList: {
          ...state.pageList,
          data: Persons,
          refetch: false,
        },
      });
      changeInitialState(Persons);
    },
    variables,
    onError(err) {
      console.log(err);
    },
  });

  const handleRefetch = () => {
    refetch();
  };

  const handleChangeIsActive = (event) => {
    setVariables({
      data: {
        ...variables.data,
        isActive: event.target.checked,
      },
    });
  };

  const columns = [
    {
      name: "id",
      label: "id",
      options: {
        display: "excluded",
        filter: false,
        sort: false,
      },
    },
    {
      name: "roleUser.name",
      label: "Adı",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "roleUser.surname",
      label: "Soyadı",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "type",
      label: "Tipi",
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "isActive",
      label: "Kayıt Durumu",
      options: {
        display: isMobile ? false : true,
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return value ? "Aktif" : "Pasif";
        },
      },
    },
    {
      name: "roleUser.username",
      label: "Email",
      options: {
        display: isMobile ? false : true,
        filter: true,
        sort: true,
      },
    },
    {
      name: "createdAt",
      label: "Kayıt Tarihi",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return value ? moment(value).format("DD.MM.YYYY") : "";
        },
      },
    },
  ];

  const options = {
    pagination: isMobile ? false : true,
    filter: true,
    print: false,
    download: false,
    viewColumns: true,
    responsive: "scrollMaxHeight",
    fixedHeader: true,
    customToolbar: () => (
      <CustomToolbar handleAdd={handleAdd} handleRefetch={handleRefetch} />
    ),
    customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (
      <CustomToolbarSelectWithUpdate
        selectedRows={selectedRows}
        displayData={displayData}
        setSelectedRows={setSelectedRows}
        mutation={rolesMutations.ROLE_DELETE}
        query={{
          query: rolesQueries.PERSONS,
          variables,
        }}
        queryData="Persons"
        deleteMethod="roleRemove"
        changeState={changeState}
        state={state}
        changeInitialState={changeInitialState}
      />
    ),
    textLabels,
  };

  useEffect(() => {
    changeState({
      pageList: {
        ...state.pageList,
        variables,
      },
    });
  }, [variables]);

  useEffect(() => {
    handleRefetch();
  }, [state.pageList.refetch && !!loading]);

  if (loading) return <Loading />;
  return (
    <div>
      <FormControlLabel
        control={
          <Switch
            checked={variables.data.isActive}
            onChange={handleChangeIsActive}
            name="isActive"
            color="primary"
          />
        }
        label={variables.data.isActive ? "Aktif Kayıtlar" : "Pasif Kayıtlar"}
      />
      <MUIDataTable
        title={"Personeller"}
        data={initialState}
        columns={columns}
        options={options}
      />
    </div>
  );
};

export default PageList;
